module.exports = __webpack_public_path__ + "static/media/eth-diamond-plain.9a323928.svg";